export const csMarkers = {
  moorland: { name: "Moorland", x: 198, y: 246 },
  pinta: { name: "Fort Pinta", x: 246, y: 253 },
  silversong: { name: "Silversong Pony Championship", x: 228, y: 235 },
  baron: { name: "Baroness' Championship", x: 144, y: 132 },
  gold: { name: "Goldenhills", x: 96, y: 150 },
  jorvik: { name: "Jorvik Stables", x: 22, y: 229 },
  silver: { name: "Silverglade Village", x: 176, y: 186 },
  grove: { name: "Firgrove", x: 326, y: 170 },
  gran: { name: "New Hillcrest", x: 124, y: 358 },
  valedale: { name: "Valedale", x: 283, y: 118 },
};

export function getNextCsInfo(t) {
  const timeLeft = getTimeToNextCs();
  return {
    location: schedule[getNextCsIndex()],
    timeLeft: timeLeft,
    timeLeftString: getTimeLeftString(timeLeft, t),
  };
}

function getLastMonday() {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const lastMonday = new Date(now);

  lastMonday.setDate(now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
  lastMonday.setHours(0, 0, 0, 0);
  return lastMonday;
}
function getNextCsIndex() {
  const now = new Date();
  const lastMonday = getLastMonday();

  const millisecondsElapsed = now - lastMonday;
  const csElapsed = Math.floor(millisecondsElapsed / (30 * 60 * 1000));

  return (csElapsed + 1) % (7 * 48);
}

function getTimeToNextCs() {
  const now = new Date();
  const lastMonday = getLastMonday();
  const millisecondsElapsed = now - lastMonday;
  return 30 * 60 * 1000 - (millisecondsElapsed % (30 * 60 * 1000));
}

function getTimeLeftString(ms, t) {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (!t) return "";
  if (minutes > 0) {
    return t("time.minutesSeconds", {
      minutes,
      seconds: remainingSeconds,
    });
  } else {
    return t("time.seconds", {
      seconds: remainingSeconds,
    });
  }
}

const schedule = [
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "gold",
  "jorvik",
  "silver",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "gran",
  "valedale",
  "gold",
  "jorvik",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "valedale",
  "baron",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "silver",
  "valedale",
  "jorvik",
  "gran",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "silver",
  "pinta",
  "baron",
  "gold",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "jorvik",
  "valedale",
  "baron",
  "pinta",
  "silversong",
  "baron",
  "gold",
  "jorvik",
  "silver",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "gran",
  "valedale",
  "gold",
  "jorvik",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "valedale",
  "baron",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "jorvik",
  "gran",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "silver",
  "valedale",
  "baron",
  "gold",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "jorvik",
  "valedale",
  "baron",
  "moorland",
  "silversong",
  "baron",
  "gold",
  "jorvik",
  "silver",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "gran",
  "valedale",
  "gold",
  "jorvik",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "valedale",
  "baron",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "gold",
  "valedale",
  "jorvik",
  "gran",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "silver",
  "moorland",
  "baron",
  "gold",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "jorvik",
  "valedale",
  "baron",
  "moorland",
  "pinta",
  "baron",
  "gold",
  "jorvik",
  "silver",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "gran",
  "valedale",
  "gold",
  "jorvik",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "valedale",
  "baron",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "valedale",
  "jorvik",
  "gran",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "silver",
  "gran",
  "baron",
  "gold",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "jorvik",
  "valedale",
  "baron",
  "moorland",
  "pinta",
  "silversong",
  "jorvik",
  "silver",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "gran",
  "valedale",
  "gold",
  "jorvik",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "valedale",
  "baron",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "gold",
  "valedale",
  "jorvik",
  "gran",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "silver",
  "jorvik",
  "baron",
  "silversong",
  "silver",
  "moorland",
  "pinta",
  "silversong",
  "grove",
  "gran",
  "jorvik",
  "valedale",
  "baron",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "gold",
  "grove",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "jorvik",
  "silver",
  "gran",
  "gold",
  "silver",
  "grove",
  "jorvik",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "gran",
  "grove",
  "jorvik",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "silver",
  "gran",
  "grove",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "jorvik",
  "silver",
  "gran",
  "grove",
  "jorvik",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "silver",
  "gran",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "jorvik",
  "silver",
  "gran",
  "grove",
  "moorland",
  "pinta",
  "silversong",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "gran",
  "grove",
  "jorvik",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "silver",
  "gran",
  "jorvik",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "grove",
  "silver",
  "jorvik",
  "gold",
  "moorland",
  "pinta",
  "silversong",
  "baron",
  "valedale",
  "silver",
  "gran",
  "grove",
  "gold",
];
